import { ALLERGENS } from './allergens.constants';

export const DIETARY_RESTRICTIONS_ICONS: string[] = [...ALLERGENS];
